import { flow, types } from 'mobx-state-tree'
import { validateRefund } from '../../../network/refund/validateRefund'
import { RootStore } from '../../store'
import { getRedeemRequest, redeemRefund } from './../../../network/refund/redeemRefund'

const MobileNumber = types.model('mobileNo', {
  countryCode: types.optional(types.string, ''),
  number: types.optional(types.number, 0),
})

export const RefundCustomerDetails = types.model('RefundCustomerDetails', {
  remitterId: types.optional(types.string, ''),
  remitterFirstName: types.optional(types.string, ''),
  remitterMiddleName: types.maybeNull(types.string),
  remitterLastName: types.maybeNull(types.string),
  remitterAccountNumber: types.maybeNull(types.string),
  mobileNumber: types.optional(MobileNumber, {}),
})
export const VoucherDetails = types.model('VoucherDetails', {
  voucherId: types.optional(types.string, ''),
  voucherCode: types.maybeNull(types.string),
  voucherReferenceNumber: types.maybeNull(types.string),
  transactionId: types.optional(types.string, ''),
  transactionDate: types.optional(types.number, 0),
  voucherAmount: types.optional(types.number, 0),
  originalTranId: types.optional(types.string, ''),
  utr: types.maybeNull(types.string),
  voucherStatus: types.optional(types.string, ''),
  remittanceDetails: types.optional(RefundCustomerDetails, {}),
  redeemTime: types.optional(types.string, ''),
})

const RefundCode = types
  .model('RefundCode', {
    voucherDetails: types.optional(VoucherDetails, {}),
  })
  .actions((self) => ({
    validateRefundCode: flow(function* validateRefundCode(refundCode: string) {
      try {
        const resp = yield validateRefund(RootStore?.agent?.session, refundCode)
        self.voucherDetails = resp
        self.voucherDetails.voucherCode = refundCode
        return resp
      } catch (err) {
        console.log('err', err)
        RootStore.message.handleError(err)
        throw err
      }
    }),
    redeemRefundApi: flow(function* redeemRefundApi() {
      const request = getRedeemRequest(RootStore.agent.agentInfo, self.voucherDetails as any)
      try {
        const resp = yield redeemRefund(RootStore?.agent?.session, request)
        self.voucherDetails.transactionId = resp?.transactionId
        self.voucherDetails.redeemTime = resp?.transactionTime
        console.log('res', resp)
        return resp
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
  }))
  .views((self) => ({
    getCustomerName: () => {
      const { remitterFirstName, remitterMiddleName, remitterLastName } = self.voucherDetails.remittanceDetails
      return [remitterFirstName, remitterMiddleName, remitterLastName]
        .filter((val) => {
          return val
        })
        .join(' ')
        .trim()
    },
  }))

const RefundCodeData = RefundCode.create({})

export { RefundCode, RefundCodeData }
